import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@siliconx/shared/ui/PageHeader';
import { Card } from '@siliconx/shared/ui/Card';
import { TermsOfServiceContent } from '../components/legal/TermsOfServiceContent';

export const Route = createFileRoute('/terms')({
  component: TermsOfServicePage,
});

/**
 * SIL-1509: public Terms of Service page (including SMS Terms), served at
 * https://portfolio.siliconx.tech/terms. Same pattern as /privacy: static
 * JSX mirrored from docs/legal/terms-of-service.md, no auth, no data
 * fetching. __root.tsx's isPublicPortalPath allowlists it so a signed-out
 * visitor (e.g. a toll-free SMS registration reviewer) sees the content.
 * Distinct from /tos, the authenticated clickwrap acceptance screen.
 */
function TermsOfServicePage() {
  return (
    <div className="mx-auto max-w-3xl">
      <div className="mb-6">
        <PageHeader title="Terms of Service" subtitle="Effective date: October 1, 2026" />
      </div>

      <Card className="space-y-6 text-sm text-foreground">
        <TermsOfServiceContent />
      </Card>
    </div>
  );
}
